import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Loader2, Mail, Lock, User } from "lucide-react";
import { AuthLayout } from "./Login";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/signup", { name, email, password });
      toast.success("Verification code sent to your email");
      navigate("/verify-otp", { state: { email } });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="text-xs uppercase tracking-[0.24em] text-cyan-400 mb-3">Join the bazaar</div>
      <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tighter">Create your account</h1>
      <p className="text-sm text-zinc-400 mt-2">Free forever. No card required.</p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="name" className="text-xs uppercase tracking-widest text-zinc-500">Name</Label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
            <Input data-testid="signup-name" id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name"
              className="h-12 pl-10 bg-white/5 border-white/10 focus-visible:ring-cyan-500/40 focus-visible:border-cyan-500/60" />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="email" className="text-xs uppercase tracking-widest text-zinc-500">Email</Label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
            <Input data-testid="signup-email" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 pl-10 bg-white/5 border-white/10 focus-visible:ring-cyan-500/40 focus-visible:border-cyan-500/60" />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password" className="text-xs uppercase tracking-widest text-zinc-500">Password</Label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
            <Input data-testid="signup-password" id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 8 characters"
              className="h-12 pl-10 bg-white/5 border-white/10 focus-visible:ring-cyan-500/40 focus-visible:border-cyan-500/60" />
          </div>
        </div>
        <Button data-testid="signup-submit" type="submit" disabled={loading} className="btn-primary w-full h-12 rounded-full font-semibold text-base">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}
        </Button>
      </form>

      <div className="mt-8 text-sm text-center text-zinc-400">
        Already have an account?{" "}
        <Link to="/login" data-testid="switch-to-login" className="text-fuchsia-400 hover:text-fuchsia-300 font-medium">Sign in</Link>
      </div>
    </AuthLayout>
  );
}
